import { callApi } from "@/services/api"
import { Game } from "@/services/types"
import {
  CasinoGameStatistic,
  Configs,
  GiveawayState,
  GiveawayType,
  GlobalState,
  LiveWinnerType,
  RootState,
} from "../types"
import { GameSlug, GiveawayStatus } from "@/services/enums"
import { ActionContext } from "vuex"

type GamesResult = {
  data: Game[]
}

export async function getGames(): Promise<GamesResult> {
  const response = await callApi.getGames()

  return {
    data: response.data.data,
  }
}

type ConfigsResult = {
  data: Configs
}

export async function getConfigs(): Promise<ConfigsResult> {
  const response = await callApi.getConfigs()

  return {
    data: response.data.data,
  }
}

type GiveawaysResult = {
  data: GiveawayType[]
}

type Payload = {
  game_slug: GameSlug
  status?: GiveawayStatus
}

export async function getGiveaways(
  ctx: ActionContext<GiveawayState, RootState>,
  payload: Payload
): Promise<GiveawaysResult> {
  const response = await callApi.giveaway.get(payload.game_slug, payload.status)

  return {
    data: response.data.data,
  }
}

type LiveWinnerResult = {
  data: LiveWinnerType[]
}

export async function getLiveWinners(): Promise<LiveWinnerResult> {
  const response = await callApi.getLiveWinners()

  return {
    data: response.data.data,
  }
}

type CasinoGameStatisticsPayload = {
  game_slug: GameSlug
}

type CasinoGameStatisticResult = {
  data: CasinoGameStatistic[]
}

export async function getCasinoGameStatistics(
  _ctx: ActionContext<GlobalState, RootState>,
  payload: CasinoGameStatisticsPayload
): Promise<CasinoGameStatisticResult> {
  const response = await callApi.getCasinoGameStatistics(payload.game_slug)

  return {
    data: response.data.data,
  }
}
